import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import Component from "../qlib/Component";


export default class LaatsteBiedingComponent extends Component
{
    constructor(element)
    {
        super(element);

        this.object_id = element.dataset.objectId;
        this.biedingOptiesSelector = '.js-bieding-select';
        this.biedingenOverviewSelector = '.js-alle-biedingen-container';

        let that = this;

        window.setInterval(function() {

            var controller = new AbortController();
            setTimeout(() => controller.abort(), 5000);
            return fetch('/makelaarlaatstebieding.php?pand_id='+that.object_id, {signal: controller.signal })
                .then(response => response.json())
                .then(result => {

                    let messageEl = $(element).find('.js-lb-message').first(),
                        infoEl = $(element).find('.js-lb-info').first();

                    if (result.bieding) {

                        // Current bieding_id
                        let el_bieding_id = element.dataset.biedingId;

                        // Latest bid is the same, do nothing
                        if (result.bieding.bieding_id == el_bieding_id) {
                            return;
                        }

                        // Get html elements to replace in element
                        let bieding = result.bieding,
                            $el = $(element),
                            $datum = $el.find('.js-lb-datum'),
                            $ovFinanciering = $el.find('.js-lb-ov-financiering'),
                            $ovKeuring = $el.find('.js-lb-ov-keuring'),
                            $ovOverig = $el.find('.js-lb-ov-overig');

                        $el.find('.js-lb-zoeker').text(bieding.zoeker_id);
                        $datum.attr('title', bieding.datum_formatted1);
                        $datum.text(bieding.datum_formatted2);
                        $el.find('.js-lb-bieding').text(bieding.bieding_formatted);

                        that.toggleConditions($ovFinanciering, bieding.voorbehouden.financiering, 'voorbehoud financiering');
                        that.toggleConditions($ovKeuring, bieding.voorbehouden.keuring, 'voorbehoud bouwtechnische keuring');
                        that.toggleConditions($ovOverig, bieding.voorbehouden.overig, 'overige ontbindende voorwaarden');

                        // Request has bieding opties and selector for element to change
                        if (result.bieding_opties && that.biedingOptiesSelector) {
                            let selectEl = $(that.biedingOptiesSelector);

                            // Remove old options
                            selectEl.children('option').each(function(){
                                if (this.value) {
                                    this.remove();
                                }
                            });

                            // Add new options
                            $.each(result.bieding_opties, function(i, item) {
                                let optionEl = document.createElement('option');
                                optionEl.value = item.value;
                                optionEl.text = item.formatted;
                                selectEl.append(optionEl);
                            });
                        }

                        // Set new bieding id data attribute
                        element.setAttribute('data-bieding-id', bieding.bieding_id);

                        if (messageEl) {
                            messageEl.addClass('d-none');
                        }

                        infoEl.removeClass('d-none');

                        // Clone current element for other html overviews
                        let $cloneEl = $el.clone();

                        // Do some fixing
                        $cloneEl.removeClass('h-100');
                        $cloneEl.removeClass('js-laatste-bieding-container');
                        $cloneEl.addClass('my-3');

                        // Remove all data attributes, just in case
                        $.each($cloneEl.data(), function (key) {
                            var attr = 'data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
                            $cloneEl.removeAttr(attr);
                        });

                        // Different laatste bieding containers available
                        $('.js-laatste-bieding-container').each(function(){
                            if (this === element) {
                                return;
                            }
                            this.innerHTML = ($cloneEl.html());
                        });

                        // Has overview selector, add to overview too
                        if (that.biedingenOverviewSelector) {
                            let allEl = $(that.biedingenOverviewSelector);

                            $cloneEl.find('.js-bieding-title').remove();
                            allEl.prepend($cloneEl);
                        }





                    } else {
                        if (messageEl) {
                            messageEl.removeClass('d-none');
                        }

                        infoEl.addClass('d-none');
                    }
                })
                .catch(error => console.log('error', error));
        }, 10000);
    }


    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    toggleConditions(el, ov, text) {
        if (ov) {
            el.attr('data-original-title', this.capitalizeFirstLetter(text));
            el.removeClass('text-muted');
        } else {
            el.attr('data-original-title', 'Geen '+text);
            el.addClass('text-muted');
        }
    }


}

SimpleComponentRegistery.register("laatste-bieding", LaatsteBiedingComponent);
